module.exports = __webpack_public_path__ + "static/media/40.543ba8df.gif";